<template >
  <div >
    <van-form >
      <base-date v-if="!emp.disable" v-model="qc.end_date" placeholder="请选择停缴时间" label="停缴时间" />
      <base-input v-model="qc.name" :rules="rules.name" :disabled="emp.disable" placeholder="请输入员工姓名" label="员工姓名" @focus="xa"/>
      <base-input v-model="qc.id_card" :rules="rules.id_card" :disabled="emp.disableS" placeholder="请输入身份证号码" label="身份证号码" />
      <van-field v-if="!emp.disable" :value="cli.reduce_reason " readonly clickable name="picker" label="减员原因" placeholder="点击选择减员原因" @click="showPicker = true" />
      <!-- <base-button :disabled="submitDisabled" native-type="submit" class="btn">提交</base-button> -->
      <van-row type="flex" justify="space-between" style="text-align: center; padding-bottom: 10px;padding-top: 20px;">
        <van-col span="12"><van-button type="info" class="btn" @click="$emit('close')">取消</van-button></van-col>
        <van-col span="12"><base-button :disabled="submitDisabled" type="info" native-type="submit" class="btn" @click="onSubmitSocialDel">提交</base-button></van-col>
      </van-row>
    </van-form>
    <div>
      <van-popup v-model="show" round position="bottom">
        <van-search v-model="emp.value" show-action label="姓名" placeholder="请输入搜索关键词" @search="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <van-picker :columns="emp_name" show-toolbar @cancel="show = false" @confirm="onConfirm" />
      </van-popup>
    </div>
    <van-popup v-model="showPicker" round position="bottom"><van-picker :columns="reduce_reason" show-toolbar @cancel="showPicker = false" @confirm="onConfirmS" /></van-popup>

  </div>
</template>

<script>
import { Wxlist, ModifyX } from '@/api/Hremployee';
import { billadd } from '@/api/Hrbill';
import { Toast } from 'vant';
export default{
  name: 'SocialCommonDel',
  props: {
    qc: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      show: false,
      emp: {
        value: '',
        disabled: true
      },
      ISshow: false,
      showPicker: false,
      empList: [],
      cli: {},
      emp_name: [],
      submitDisabled: false,
      end_date: '',
      name: sessionStorage.getItem('name'),
      id_card: parseInt(sessionStorage.getItem('id_card')),
      reduce_reason: ['合同到期', '主动离职', '辞退'],
      del_reason: '',
      reason: '',
      reasonlist: ['主动离职', '辞退', '合同到期'],
      rules: {
        name: [{ required: true,
          pattern: this.CONST.REG_EXP.PERSON_NAME,
          message: '姓名不能少于2个字符'
        }],
        id_card: [{ required: true,
          pattern: this.CONST.REG_EXP.ID_CARD,
          message: '输入的身份证号码不符合规范'
        }],
        mobile: [{ required: true,
          pattern: this.CONST.REG_EXP.MOBILE,
          message: '输入的手机号码不符合规范'
        }]
      }
    };
  },
  beforeMount() {
    if (sessionStorage.getItem('who') === '0') {
      this.emp.disable = false;
      this.emp.disableS = false;
      this.qc.name = '';
      this.emp.status = 2;
      this.qc.id_card = '';
      this.id_card = '';
      this.qc.apply_salary = '';
      this.query();
    } else {
      this.qc.emp_id = parseInt(sessionStorage.getItem('emp_id'));
      this.qc.name = sessionStorage.getItem('username');
      this.qc.id_card = sessionStorage.getItem('id_card');
      console.log(sessionStorage.getItem('id_card').length);
      if (sessionStorage.getItem('id_card').length > 0) {
        this.emp.disableS = true;
      } else {
        this.emp.disableS = false;
      }
      this.emp.disable = true;
    }
  },
  methods: {

    xa() {
      this.show = true;
      this.query();
    },
    onSearch() {
      this.query();
    },
    sbjy(value, value1) {
      this.reason = value;
      this.del_reason = '0';
    },
    onConfirmS(value, index) {
      this.showPicker = false;
      this.cli.reduce_reason = value;
      this.cli.redu_id = index;
    },
    onSubmitSocialDel() {
      this.submitDisabled = true;
      Toast.loading({
        message: '提交中',
        forbidClick: true
      });
      const qc = this._.cloneDeep(this.qc);

      billadd({
        client_id: parseInt(sessionStorage.getItem('client_id')),
        emp_id: qc.emp_id ? qc.emp_id : parseInt(sessionStorage.getItem('emp_id')),
        name: qc.name,
        add_month: qc.end_date ? qc.end_date : null,
        type: '社保-减员',
        create_id: parseInt(sessionStorage.getItem('create_id')),
        status: this.emp.status ? this.emp.status : 1,
        reduce_reason: this.cli.redu_id ? (this.cli.redu_id + 1).toString() : null,
        id_card: qc.id_card,
        check_type: 1
      }).then(resp => {
        this.submitDisabled = false;

        if (resp.success) {
          Toast.success('提交成功');
          this.$emit('close');
        } else {
          Toast.fail('提交失败');
        }
      });
    },
    onConfirm(value, index) {
      if (this.empList[index].id_card === undefined) {
        this.emp.disabled = false;
        this.qc.id_card = '';
      } else {
        this.qc.id_card = this.empList[index].id_card;
        this.emp.disabled = true;
      }
      this.qc.name = this.emp_name[index].text;
      if (this.emp_name[index].disabled) {
        Toast('该员工已提交工单！');
      } else {
        this.show = false;
      }
      this.qc.phone = this.empList[index].phone;
      this.qc.emp_id = this.empList[index].id;
      if (this.empList[index].client_id !== undefined) {
        this.qc.client_id = this.empList[index].client_id;
      }
    },
    query() {
      this.emp_name = [];
      this.empList = [];
      Wxlist({ client_id: parseInt(sessionStorage.getItem('client_id')), name: this.emp.value ? this.emp.value : null }).then(res => {
        for (let i = 0; i < res.rows.length; i++) {
          if (res.rows[i].function_ids.indexOf('10') === 0 && res.rows[i].s_base !== undefined) {
            // this.emp_name[i].disabled = false;
            this.empList.push({
              id: res.rows[i].id,
              id_card: res.rows[i].id_card,
              name: res.rows[i].name,
              phone: res.rows[i].phone,
              client_id: res.rows[i].client_id
            });
            this.emp_name.push({ text: res.rows[i].name, disabled: false });
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.btn {
  display: block;
  margin: 0 auto;
  margin-top: 100px;
  width: 80%;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/hr/social/common-del.vue